<template>
  <div class="agenda-user-col">
    <div class="picture">
      <img v-if="row" width="100%" :src="row.user.photo" alt="">
    </div>
    <div class="name subheading">
      {{ row ? row.user.name : null }}
    </div>
    <div class="activity">
      <div class="indicator" @click="addTask(indicator)" :class="[indicator.color, indicator.pointer]" v-for="indicator in _indicators"></div>
    </div>
  </div>
</template>
<script>
let newIndicator = {
  color: null,
  col: null
}
export default {
  props: {
    row: {},
  },
  computed: {
    _indicators() {
      let indicators = []

      _.each(this.row.columns, column => {
        let indicator = _.clone(newIndicator)
        indicator.col = column
        let h8 = (8 * 60 * 60);

        if (column.time_used < 3) {
          indicator.color = 'green'
          indicator.pointer = 'pointer'
        }
        if (column.time_used >= 2 && column.time_used < h8) {
          indicator.color = 'yellow'
          indicator.pointer = 'pointer'
        }
        if (column.time_used >= h8) {
          indicator.color = 'red'
        }

        indicators.push(indicator)
      })

      return indicators
    }
  },
  methods: {
    addTask(indicator) {
      if (indicator.color === 'red') return
      this.$root.$emit('TaskModal::create-task', {row: this.row, col: indicator.col})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/agenda-v2/calendar/user-column.vue